import React, { useState, useEffect } from 'react';
import { Card, Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ChargingBASE_URL } from "../../Config";

const ActiveAgent = () => {
  const [agentData, setAgentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch agent data
  const fetchAgentData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${ChargingBASE_URL}GetAgentData`, {
        method: 'GET',
        headers: {
          'accept': '*/*',
        },
      });

      if (!response.ok) throw new Error('Failed to fetch agent data');

      const data = await response.json();
      setAgentData(data); // Set agent data

    } catch (error) {
      console.error('Error fetching agent data:', error);
      setError('Error fetching agent data.');
    } finally {
      setLoading(false);
    }
  };

  // Call fetchAgentData on component mount
  useEffect(() => {
    fetchAgentData();
  }, []);

  return (
    <Container className="py-5">
      {error && <Alert variant="danger" className="text-center">{error}</Alert>}

      <Row className="justify-content-center">
        <Col xs={12} md={6}>
          <Card className="text-white bg-primary h-100 rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Active Agents </Card.Title>
              <Card.Text className="display-4">
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  agentData ? agentData.todayActivefrontAgent : 'No Data'
                )}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ActiveAgent;
